export { I18nManager } from './I18nManager';
export type { Language } from './I18nManager';
